module.exports = "../study/imgs/maps/Kanagawa/S8/Hazard/Slopefailure/Kanagawa_Slopefailure_HadGEM2_RCP26_End.png";